import React, { useState, useEffect } from "react";
import debounce from "debounce-promise";
import qs from "query-string";
import styles from "../styles.module.css";

export const fetchAutocomplete = debounce(
    (input) => {
        if (!input) return Promise.resolve([]); // Don't fetch on empty input

        const queryString = qs.stringify({
            nameStart: input,
            minPopulation: 250000,
        });

        return fetch(
            `https://6i9d7zjpoa.execute-api.eu-west-1.amazonaws.com/production/?${queryString}`
        )
            .then(res => res.json())
            .catch(() => []);
    },
    300
);

export const HomeCityField = ({ input, placeholder, inputClass, placeholderClass, handleErrors, ...props }) => {
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);

    useEffect(() => {
        if (props.meta.touched) {
            handleErrors({
                name: input.name,
                error: props.meta.error || null,
            });
        }
    }, [props.meta.error, props.meta.touched, input.value]);

    const handleChange = (event) => {
        const value = event.target.value;
        input.onChange({ name: value, geonamesId: "" });

        if (value) {
            setShowSuggestions(true);
            fetchAutocomplete(value).then((items) => setSuggestions(items));
        } else {
            setSuggestions([]);
            setShowSuggestions(false);
        }
    };

    const handleSelect = (city) => {
        const formattedName = `${city.displayName}, ${city.country}`;
        input.onChange({ name: formattedName, geonamesId: city.geonamesId });
        setSuggestions([]);
        setShowSuggestions(false);
    };

    return (
        <>
            <input
                className={`${styles.input} ${styles.default_text_size} ${props.meta.error && props.meta.touched ? styles.error_input : ""} ${inputClass}`}
                {...input}
                id={input.name}
                value={input?.value?.name || ""}
                onChange={handleChange}
                onBlur={() => {
                    setTimeout(() => {
                        setShowSuggestions(false);
                        if (!input.value?.geonamesId) {
                            input.onChange(null);
                        }
                    }, 0);
                }}
                placeholder={placeholder}
                onFocus={() => input.value?.name && setShowSuggestions(true)}
            />

            {showSuggestions && suggestions.length > 0 && (
                <div
                    style={{
                        position: "absolute",
                        width: "100%",
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        borderTop: "none",
                        maxHeight: "200px",
                        overflowY: "auto",
                        zIndex: 1000,
                        color: "black"
                    }}
                >
                    {suggestions.map((city) => (
                        <div
                            key={city.geonamesId}
                            style={{
                                padding: "8px",
                                cursor: "pointer",
                                borderBottom: "1px solid #eee",
                            }}
                            onMouseDown={() => handleSelect(city)}
                        >
                            {city.displayName}, {city.country}
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};

export function ContactInfoCityInput({ value, onChange, error }) {
    const [suggestions, setSuggestions] = useState([])
    const [showSuggestions, setShowSuggestions] = useState(false)

    const handleInputChange = (e) => {
        const val = e.target.value
        onChange({ name: val, geonamesId: "" })
        if (val) {
            setShowSuggestions(true)
            fetchAutocomplete(val).then(setSuggestions)
        } else {
            setSuggestions([])
            setShowSuggestions(false)
        }
    }

    const handleSelect = (city) => {
        onChange({
            name: `${city.displayName}, ${city.country}`,
            geonamesId: city.geonamesId,
            __typename: "City",
        })
        setSuggestions([])
        setShowSuggestions(false)
    }

    return (
        <div className="relative">
            <label className="block mb-1 text-black">Home base city:</label>
            <input
                type="text"
                className="w-full text-black border p-2 rounded bg-gray-300"
                style={{
                    borderColor: error ? "#e53935" : "#404040"
                }}
                value={value?.name || ""}
                onChange={handleInputChange}
                onFocus={() => {
                    if (value?.name) setShowSuggestions(true)
                }}
            />
            {error && <p className="text-red-500 text-sm">{error}</p>}

            {showSuggestions && suggestions.length > 0 && (
                <div className="absolute z-10 w-full bg-white border max-h-60 overflow-y-auto text-black">
                    {suggestions.map((city) => (
                        <div
                            key={city.geonamesId}
                            className="p-2 hover:bg-gray-100 cursor-pointer"
                            onMouseDown={() => handleSelect(city)}
                        >
                            {city.displayName}, {city.country}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}
